import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';

const MOBILE_GAP = 16;

const PartnerLogoGridMobileComponent = ({ data }) => {
  const navigate = useNavigate();
  const { title, description, cards = [], component = 'h2' } = data || {};

  return (
    <ScrollFadeSection
      sx={{
        width: '100%',
        maxWidth: '100vw',
        backgroundColor: '#E3E6E8',
        borderRadius: '34px',
        px: '16px',
        py: '32px',
        boxSizing: 'border-box',
      }}
    >
      <Typography
        component={component}
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 700,
          fontSize: '2rem',
          lineHeight: '2.125rem',
          letterSpacing: '-0.03em',
          textAlign: 'center',
          color: '#162F3B',
          mb: '16px',
          whiteSpace: 'pre-line',
        }}
      >
        {title}
      </Typography>

      {description && (
        <Box
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '1.25rem',
            lineHeight: '1.5rem',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            color: '#162F3B',
            maxWidth: '343px',
            mx: 'auto',
            mb: '24px',
            '& p': { m: 0, mb: '12px' },
            '& p:last-of-type': { mb: 0 },
            '& a': {
              color: '#162F3B',
              textDecoration: 'underline',
              fontWeight: 400,
            },
            '& a:hover': {
              opacity: 0.85,
            },
          }}
          dangerouslySetInnerHTML={{ __html: description || '' }}
        />
      )}

      {cards.length > 0 && (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, minmax(0, 1fr))',
              sm: 'repeat(3, minmax(0, 1fr))',
            },
            gap: `${MOBILE_GAP}px`,
          }}
        >
          {cards.map((card, index) => {
            const isClickable = Boolean(card?.url);
            const Component = isClickable ? 'button' : 'div';

            return (
              <ScrollFadeWrapper
                key={`${card?.imageAltTitle || card?.imgAltTag || 'card'}-${index}`}
                delay={index * 0.06}
              >
                <Box
                  component={Component}
                  type={isClickable ? 'button' : undefined}
                  onClick={isClickable ? () => navigate(card.url) : undefined}
                  aria-label={
                    isClickable
                      ? `View ${card.imageAltTitle || card.imgAltTag}`
                      : undefined
                  }
                  sx={{
                    minHeight: '92px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '20px',
                    boxShadow:
                      '0px 6px 16px 0px rgba(22, 47, 59, 0.12), 0px 1px 2px 0px rgba(162, 172, 177, 0.12)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: '12px',
                    py: '16px',
                    appearance: 'none',
                    border: 'none',
                    cursor: isClickable ? 'pointer' : 'default',
                    font: 'inherit',
                  }}
                >
                  {card?.logo && (
                    <Image
                      width={160}
                      height={88}
                      src={card.logo}
                      alt={card.imgAltTag || `partner-logo-${index + 1}`}
                      title={card.imageAltTitle || ''}
                      loading="eager"
                      sx={{
                        maxWidth: '100%',
                        maxHeight: '48px',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  )}
                </Box>
              </ScrollFadeWrapper>
            );
          })}
        </Box>
      )}
    </ScrollFadeSection>
  );
};

export default PartnerLogoGridMobileComponent;
